import React from "react";
import styles from "../../../styles/Footer.module.css";
import pwcLogo from "../../../assets/Wrap.png"
import { IoIosInformationCircleOutline } from "react-icons/io";
import { Button, Grid2, Link, Typography } from "@mui/material";

const Footer = ({ menus }) => {

    return (
        <div className={styles.footer}>
            <Grid2 container sx={{ mt: 20, opacity: '0.6' }}>

                <Grid2 size={{ xs: 12, md: 2 }}>
                    <Typography variant="body2" sx={{ fontSize: '14px', color: '#696969' }}>
                        Version: V1.2025
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 8 }}>
                    <Typography variant="body2" textAlign={"center"} sx={{ fontSize: '14px', color: '#252525' }}>
                        &copy; 2025 PwC. All rights reserved. PwC refers to india member firm and may sometimes refer to the PwC network. Each member firm is a separate legal entity. Please see <Link target="_blank" href="https://www.pwc.com/structure" sx={{ color: '#000' }}>www.pwc.com/structure</Link> for further details.
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 2 }} />
                <Grid2 size={{ xs: 12, md: 12 }} textAlign={"center"}>
                    <Link href="#" className={styles.footer_link}>Legal Disclaimers</Link> | <Link href="#" className={styles.footer_link}>Contact Support</Link> | <Link href="#" className={styles.footer_link}>Click me!</Link>
                </Grid2>
            </Grid2>
        </div>
    );
};

export default Footer;
